import React, { useState } from "react";
import "./contact_details.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import { db } from "../../firebase";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  const [alert, setAlert] = useState({ showSnackbar: false, message: "" });
  const [loading, setLoading] = useState(false);
  const history = useNavigate();
  const goback = () => {
    history("/");
  };
  const closeSnack = () => {
    setAlert({
      showSnackbar: false,
    });
  };
  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  if (loading) {
    return (
      <div className="loading">
        <CircularProgress id="circular_bar" color="success" />
        <p>Please wait...</p>
      </div>
    );
  }
  const submitForm = (e) => {
    e.preventDefault();
    if (data.name === "") {
      setAlert({
        showSnackbar: true,
        message: "Please enter your name",
      });
    } else if (data.email === "") {
      setAlert({
        showSnackbar: true,
        message: "Please enter a valid email",
      });
    } else if (data.phone === "" || data.phone.length < 10) {
      setAlert({
        showSnackbar: true,
        message: "Please enter a valid phone number",
      });
    } else if (data.message === "") {
      setAlert({
        showSnackbar: true,
        message: "Please enter your message",
      });
    } else {
      setLoading(true);
      db.collection("contacts")
        .add({
          name: data.name,
          email: data.email,
          phone: data.phone,
          message: data.message,
        })
        .then((res) => {
          if (res) {
            setLoading(false);
            setAlert({
              showSnackbar: true,
              message: "Thank you . I will get back to you....",
            });
            setData({
              name: "",
              email: "",
              phone: "",
              message: "",
            });
          } else {
            setAlert({
              showSnackbar: true,
              message: "Oops!s something went wrong....",
            });
          }
        });
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact with me</title>
        <meta
          name="keywords"
          content="Contact with me If you have any queries about me. I will get back to you very shortly."
        />
        <link rel="canonical" href="/contact" />
      </Helmet>
      <div className="contact_div">
        <ArrowBackIosIcon id="back_arrow" htmlColor="white" onClick={goback} />
        <p className="contact_heading">Kindly Enter the Following Details</p>
        <form className="contact_form">
          <div className="input_div">
            <PersonOutlineIcon htmlColor="white" />
            <input
              type="text"
              placeholder="Enter your name"
              className="name_input"
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
          </div>
          <div className="input_div">
            <MailOutlineIcon htmlColor="white" />
            <input
              type="email"
              placeholder="Enter your email"
              className="email_input"
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />
          </div>
          <div className="input_div">
            <PhoneAndroidIcon htmlColor="white" />
            <input
              type="tel"
              placeholder="Enter your phone"
              className="phone_input"
              value={data.phone}
              onChange={(e) => setData({ ...data, phone: e.target.value })}
            />
          </div>

          <textarea
            type="text"
            rows="5"
            placeholder="Enter your message"
            className="message_input"
            value={data.message}
            onChange={(e) => setData({ ...data, message: e.target.value })}
          />
          <button className="submit_btn" onClick={(e) => submitForm(e)}>
            Submit
          </button>
        </form>
        <Snackbar
          ContentProps={{
            sx: {
              background: "#1a1527",
              color: "white",
              border: "1px solid white",
              borderRadius: "10px",
            },
          }}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          open={alert.showSnackbar}
          message={alert.message}
          autoHideDuration={3000}
          onClose={closeSnack}
        />
      </div>
    </>
  );
};

export default Contact;
